// extracted by mini-css-extract-plugin
export default {"modal":"answer-quotation_modal__NtXGO","content":"answer-quotation_content__dQvD6"};